exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header{padding-top:200px;padding-bottom:50px;z-index:1000}@media (max-width:1440px){.page-header{padding-top:180px}}@media (max-width:991px){.page-header{padding-top:120px}}@media (max-width:768px){.page-header{padding-top:60px;padding-bottom:50px}}@media (max-width:576px){.page-header{padding-top:40px;padding-bottom:30px}}.page-header .top-banner-wrap{text-align:center}.page-header .top-banner-wrap img{width:85%;max-width:900px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bbd339a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/subview/PageHeader.vue
// module id = 134
// module chunks = 0